<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  task: {
    type: Object,
    default: () => ({}),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);

const description = computed(() =>
  props.task?.title
    ? t('TASKS.LIST.DELETE.DESCRIPTION_WITH_TITLE', {
        taskTitle: props.task.title,
      })
    : t('TASKS.LIST.DELETE.DESCRIPTION')
);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('TASKS.LIST.DELETE.TITLE')"
    :description="description"
    :confirm-button-label="t('TASKS.LIST.DELETE.CONFIRM')"
    :is-loading="isLoading"
    @confirm="emit('confirm')"
  />
</template>
